var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowseDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26.5924,
    rx: 2,
    stroke: "#CECECE",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5924H16C16.55 18.5924 17 18.1424 17 17.5924V12.5924H18.59C19.48 12.5924 19.93 11.5124 19.3 10.8824L14.71 6.29244C14.6175 6.19974 14.5076 6.12619 14.3866 6.07601C14.2657 6.02583 14.136 6 14.005 6C13.874 6 13.7443 6.02583 13.6234 6.07601C13.5024 6.12619 13.3925 6.19974 13.3 6.29244L8.71 10.8824C8.08 11.5124 8.52 12.5924 9.41 12.5924H11V17.5924C11 18.1424 11.45 18.5924 12 18.5924ZM8 20.5924H20C20.55 20.5924 21 21.0424 21 21.5924C21 22.1424 20.55 22.5924 20 22.5924H8C7.45 22.5924 7 22.1424 7 21.5924C7 21.0424 7.45 20.5924 8 20.5924Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseDeviceIcon);
export default __webpack_public_path__ + "static/media/browse-device-icon.d3f0d2a28e3f7aa007bf7ee1e951a625.svg";
export { ForwardRef as ReactComponent };